import { TooltipConfig, Tooltip } from '../../ui/Tooltip';

export class UIService {
  constructor(private scene: Phaser.Scene) {}

  public showTooltip(config: TooltipConfig): void {
    const tooltip = new Tooltip({
      scene: this.scene,
      text: config.text,
      x: config.x,
      y: config.y,
      autoHideDelayMs: config.autoHideDelayMs,
      maxWidth: 160,
    });

    tooltip.show();
  }
}
